export const orderHeaders = [
  { label: "Order", largeWidth: false, alignRight: false },
  { label: "Customer Name", largeWidth: true, alignRight: false },
  { label: "Customer Email", largeWidth: true, alignRight: false },
  { label: "Amount", largeWidth: false, alignRight: false },
  { label: "Transaction Date", largeWidth: false, alignRight: false },
  { label: "Status", largeWidth: false, alignRight: true },
];
